"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = void 0;
const api = __importStar(require("./apis/login"));
const setTokens_1 = require("./setTokens");
const GqlError_1 = require("../utils/GqlError");
const eventManager_1 = require("../utils/eventManager");
const newRelicEvents_1 = require("../utils/newRelicEvents");
function login(params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'login_start' });
            const tokens = yield api.login(params);
            const { idToken, accessToken } = tokens;
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'login_success' });
            eventManager_1.emit('login.success', tokens);
            yield setTokens_1.setTokens({
                idToken,
                accessToken,
                callInitSession: true,
                broadcast: true,
                authActionType: 'login',
            });
            return tokens;
        }
        catch (e) {
            if (e instanceof GqlError_1.MfaRequiredError) {
                eventManager_1.emit('mfa required', e.mfaPayload);
            }
            else {
                newRelicEvents_1.sendNewRelicEvent({
                    EventName: 'login_failed',
                    criticalError: e.criticalError,
                    error_code: e.code,
                    description: e.description,
                });
                eventManager_1.triggerError('login', e);
            }
            throw e;
        }
    });
}
exports.login = login;
